import { Box } from '@mui/material';
import { LoadingSkeleton, TableTitleBox } from '../../common/components';
import UpdateDebtFilters from './components/UpdateDebtFilters';
import UpdateDebtDataTable from './components/UpdateDebtDataTable';
import UpdateDebtPagination from './components/UpdateDebtPagination';
import UpdateDebtEditDialog from './components/UpdateDebtEditDialog';
import UpdateDebtDetailsDialog from './components/UpdateDebtDetailsDialog';
import { useUpdateDebtTable } from './hooks/useUpdateDebtTable';

/**
 * Componente principal para actualizar deudas de cupones
 * Refactorizado para usar TanStack Query y seguir los patrones del proyecto
 */
const UpdateDebtTable = () => {
  const {
    data,
    isLoading,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    filter,
    
    editDialogOpen,
    detailsDialogOpen,
    selectedItem,
    
    plans,
    groups,
    
    handleFilter,
    handlePageChange,
    handleRowsPerPageChange,
    handleOpenEditDialog,
    handleCloseEditDialog,
    handleOpenDetailsDialog,
    handleCloseDetailsDialog,
    handleSaveDebtUpdate,
  } = useUpdateDebtTable();

  if (isLoading) { return <LoadingSkeleton />; }

  return (
    <Box>
      <TableTitleBox title="Habitat 99 | Mora | Actualizar Deuda" />

      <UpdateDebtFilters
        filter={filter}
        handleFilter={handleFilter}
        plans={plans}
        groups={groups}
      />

      <UpdateDebtDataTable
        data={data}
        isLoading={isLoading}
        onEdit={handleOpenEditDialog}
        onViewDetails={handleOpenDetailsDialog}
        LoadingComponent={LoadingSkeleton}
      />

      <UpdateDebtPagination
        totalPages={totalPages}
        totalCount={totalCount}
        page={page}
        onPageChange={handlePageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <UpdateDebtEditDialog
        open={editDialogOpen}
        onClose={handleCloseEditDialog}
        onSave={handleSaveDebtUpdate}
        selectedItem={selectedItem}
        plans={plans}
      />

      <UpdateDebtDetailsDialog
        open={detailsDialogOpen}
        onClose={handleCloseDetailsDialog}
        selectedItem={selectedItem}
      />
    </Box>
  );
};

export default UpdateDebtTable;
